<script setup lang="ts">
import abbrev from '@/utils/abbrev';

/********************
 * PROPS & EMITS     *
 ********************/
export interface CiMapMarkerClusterProps {
  clusterAvailableCount?: number;
  clusterItemCount: number;
  clusterItemLabel?: string;
  isAsSearch?: boolean;
  locale: string;
}
const props = withDefaults(defineProps<CiMapMarkerClusterProps>(), {
  clusterAvailableCount: 0,
  clusterItemLabel: '',
  isAsSearch: false,
});

/********************
 * REFS & VARS       *
 ********************/
const itemCount = computed(() => {
  if (props.clusterItemCount > 99) {
    return '99+';
  }
  return props.clusterItemCount;
});
</script>

<template>
  <div
    class="map-marker__container"
    :class="{
      'map-marker__container--is-circle': !props.clusterItemLabel,
      'map-marker__container--is-label': !!props.clusterItemLabel,
      'map-marker__container--no-info': props.isAsSearch && props.clusterAvailableCount === 0,
    }"
  >
    <div class="map-marker__animation">
      <div
        v-if="props.clusterItemLabel"
        class="map-marker__map-label whitespace-nowrap"
      >
        {{ props.clusterItemLabel }} (<span class="font-bold">{{
          abbrev(props.locale, props.clusterItemCount, 1)
        }}</span>)
      </div>
      <div
        v-else
        class="map-marker flex items-center justify-center whitespace-nowrap"
      >
        <span
          v-if="props.clusterAvailableCount"
          class="map-marker__availability-count absolute"
        />
        <span class="item-count">{{ itemCount }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
$marker-width: 32px + 2 * 4px;
$marker-height: $marker-width;

.map-marker__container {
  .map-marker {
    @apply h-full w-full rounded-full bg-white align-middle text-sm font-bold text-primary;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  }

  .map-marker__map-label {
    @apply rounded-[12px] border-[3px] border-primary bg-white px-2 py-[0.8px] text-sm font-normal;
  }

  .map-marker__availability-count {
    @apply right-0 top-0 block size-[11px] rounded-full bg-info text-xs;
  }

  .no-touch &:hover,
  &.active {
    .map-marker {
      @apply bg-primary text-white;
    }
  }

  .map-marker__animation {
    @apply h-full w-full;
    animation-name: fade;
    animation-duration: 0.25s;
    animation-fill-mode: both;
  }

  &--is-circle {
    @apply fill-white;
    height: $marker-height;
    // left: -$marker-width / 2;
    // top: -$marker-height;
    width: $marker-width;
  }

  &--is-label {
    transform: translate(-50%, -50%);
  }

  // &--no-info {
  //   .map-marker {
  //     background: $light-gray-20;
  //     color: $light-gray;
  //   }
  // }
}
</style>
